import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  leading?: ReactNode;
}

/** Header without × — nested iframe can't close MAX; use system Back / gesture instead. */
export function PageHeader({ title, subtitle, leading }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div className="page-header__row">
        {leading ? <div className="page-header__leading">{leading}</div> : null}
        <div className="page-header__text min-w-0 flex-1">
          <h1 className="page-header__title">{title}</h1>
          {subtitle ? <p className="page-header__subtitle">{subtitle}</p> : null}
        </div>
      </div>
    </header>
  );
}
